import React, { useState } from "react";
import { Button, Drawer } from "antd";
import Depop from "../../../assets/images/Header/logo.png";
import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { getCookie } from "../../../helper/cookie";
import DrawerSub from "../DrawerSub";
import "./DrawerMain.scss";

function DrawerMain({ open, setOpen }) {
  const [activeGender, setActiveGender] = useState(null); // giới tính đang mở DrawerSub
  const token = getCookie("token");

  const onClose = () => setOpen(false);

  const categories = [
    "Nữ",
    "Nam",
    "Trẻ em",
    "Thể thao",
    "Thương hiệu",
    "Trending",
    "Sales",
  ];

  return (
    <Drawer
      placement="left"
      onClose={onClose}
      open={open}
      className="drawer-sub"
    >
      <div className="drawer-wrapper">
        <div className="drawer-img">
          <img src={Depop} alt="Logo" />
        </div>

        <div className="drawer-btn">
          <Link to={`${token ? "products/create" : ""}`}>
            <Button className="drawer-btn sell">Bán ngay</Button>
          </Link>
          <Link to="/register">
            <Button className="drawer-btn signUp">Đăng kí</Button>
          </Link>
          <Link to="/login">
            <Button className="drawer-btn signIn">Đăng nhập</Button>
          </Link>
        </div>

        {/* Danh sách cate chính */}
        {!activeGender && (
          <div className="drawer-cate">
            {categories.map((item) => (
              <div
                key={item}
                className="cate-item"
                onClick={() => setActiveGender(item)}
              >
                <span>{item}</span>
                <FaArrowRightLong />
              </div>
            ))}
          </div>
        )}

        {/* DrawerSub hiển thị khi chọn gender */}
        {activeGender && (
          <DrawerSub
            gender={activeGender}
            onBack={() => setActiveGender(null)}
          />
        )}
      </div>
    </Drawer>
  );
}

export default DrawerMain;
